<template>
  <div v-if="alertMsg.length > 0" :class="`alert alert-${type} alert-dismissible fade show position-absolute`" style="top: 70px; right: 10px;" role="alert">
    {{alertMsg}}
    <button type="button" class="btn-close" @click="alertMsg=''"></button>
  </div>
</template>

<script>
  export default {
    name: 'alert',
    props: {
      msg: {type: String, default: ''},
      type: {type: String, default: 'success'},
    },
    data(){
      return({
        alertMsg: ''
      })
    },
    watch:{
      msg: {
        handler: function () {
          this.alertMsg= this.msg
        }
      },
    }
  };
</script>
